/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Gh_Err_RunningInputs */

const en_adm_gh_err_running = /** @type {(inputs: Adm_Gh_Err_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An import is already running. Wait for it to finish.`)
};

const de_adm_gh_err_running = /** @type {(inputs: Adm_Gh_Err_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es läuft bereits ein Import. Warte, bis er fertig ist.`)
};

/**
* | output |
* | --- |
* | "An import is already running. Wait for it to finish." |
*
* @param {Adm_Gh_Err_RunningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_gh_err_running = /** @type {((inputs?: Adm_Gh_Err_RunningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Gh_Err_RunningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_gh_err_running(inputs)
	return en_adm_gh_err_running(inputs)
});